<script>
import substanceDictionaries from "@core/mixins/substance-dictionaries";
import { BCardTitle, BListGroup, BListGroupItem, BBadge, BFormRadio, BCard, BRow, BCol, BFormGroup, BButton,
    BFormInput } from 'bootstrap-vue'
import vSelect from 'vue-select'
import { VueAutosuggest } from 'vue-autosuggest'
import {SubstanceLists} from "@/libs/substance";
import {RegulatedPropertyType} from "@core/domain/substance";
import TreeSelect from "@core/components/common/TreeSelect.vue";

export default {
    mixins: [substanceDictionaries],
    components: {
        BCard, BButton, BRow, BCol, BFormGroup, BCardTitle,
        BFormInput, VueAutosuggest, vSelect, BBadge, BFormRadio, TreeSelect, BListGroup, BListGroupItem,
    },
    props: {
        readOnly: {
            default: false,
        },
        compactView: {
            default: false
        },
        isMaterialCategoryMandatory: {
            type: Boolean,
            default: true
        },
        properties: {
            required: true,
            type: Object,
        }
    },
    data() {
        return {
            materialCategory: [],
            mixtureCategory: [],

            suggestions: [],
            searchTimer: null,
        };
    },
    methods: {
        normalize(node) {
            return {id: node.id, label: node.title};
        },

        onMaterialCategoryChange(value) {
            this.materialCategory = value;
            this.emit();
        },

        onMixtureCategoryChange(value) {
            this.mixtureCategory = value;
            this.emit();
        },

        emit() {
            const data = {};
            data[RegulatedPropertyType.MIXTURE_CATEGORY] = this.mixtureCategory;
            data[RegulatedPropertyType.MATERIAL_CATEGORY] = this.materialCategory;
            this.$emit('change', SubstanceLists.CANDIDATE_LIST, data);
        },
    },
    created() {
        this.initSubstanceDictionaries();
    },
    watch: {
        details() {
            if (this.properties[RegulatedPropertyType.MATERIAL_CATEGORY]) {
                this.materialCategory = this.properties[RegulatedPropertyType.MATERIAL_CATEGORY];
            }
            if (this.properties[RegulatedPropertyType.MIXTURE_CATEGORY]) {
                this.mixtureCategory = this.properties[RegulatedPropertyType.MIXTURE_CATEGORY];
            }
        }
    }
}
</script>

<template>
    <div>
        <b-row v-if="compactView">
            <b-col>
                <b-row>
                    <b-col>
                        <b-form-group :label="$t('Component(CompositionSubstance):mixture-category')">
                            <TreeSelect
                                :options="mixtureCategories"
                                :title="$t('Component(CompositionSubstance):hover-mixture-category')"
                                :placeholder="$t('Component(CompositionSubstance):mixture-category-placeholder')"
                                :value="mixtureCategory"
                                @input="onMixtureCategoryChange"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group :label="$t('Component(CompositionSubstance):material-category')">
                            <TreeSelect
                                :options="materialCategories"
                                :title="$t('Component(CompositionSubstance):hover-material-category')"
                                :placeholder="$t('Component(Placeholder):select-or-search')"
                                :value="materialCategory"
                                @input="onMaterialCategoryChange"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row v-else>
            <b-col md="5" lg="5">
                <b-row>
                    <b-col>
                        <b-form-group :label="$t('Component(CompositionSubstance):mixture-category')">
                            <TreeSelect
                                :options="mixtureCategories"
                                :title="$t('Component(CompositionSubstance):hover-mixture-category')"
                                :placeholder="$t('Component(CompositionSubstance):mixture-category-placeholder')"
                                :value="mixtureCategory"
                                @input="onMixtureCategoryChange"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-col>
            <b-col md="7" lg="7">
                <b-row>
                    <b-col>
                        <b-form-group :label="$t('Component(CompositionSubstance):material-category')">
                            <TreeSelect
                                :options="materialCategories"
                                :title="$t('Component(CompositionSubstance):hover-material-category')"
                                :placeholder="$t('Component(Placeholder):select-or-search')"
                                :value="materialCategory"
                                @input="onMaterialCategoryChange"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>
